import { useTranslation } from 'react-i18next';

const SERVICE_ICONS = [
  'ri-group-2-line',
  'ri-user-heart-line',
  'ri-building-2-line',
  'ri-focus-3-line',
  'ri-graduation-cap-line',
];

export default function ServiceCards() {
  const { t } = useTranslation();

  const cards = [
    { icon: SERVICE_ICONS[0], tagKey: 'Core Offering', titleKey: 'services.c1Title', descKey: 'services.c1Desc', featured: true },
    { icon: SERVICE_ICONS[1], titleKey: 'services.c2Title', descKey: 'services.c2Desc', featured: false },
    { icon: SERVICE_ICONS[2], titleKey: 'services.c3Title', descKey: 'services.c3Desc', featured: false },
    { icon: SERVICE_ICONS[3], titleKey: 'services.c4Title', descKey: 'services.c4Desc', featured: false },
    { icon: SERVICE_ICONS[4], titleKey: 'services.c5Title', descKey: 'services.c5Desc', featured: false },
  ];

  return (
    <section className="bg-canvas py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">{t('services.sectionBadge')}</span>
          <div className="w-10 h-px bg-sage mt-3" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
          <div className="lg:col-span-3 bg-beige rounded-2xl p-10 flex flex-col justify-between min-h-[360px]">
            <div>
              <span className="inline-block text-xs uppercase tracking-widest text-white/80 font-inter font-medium bg-white/15 px-3 py-1 rounded-full mb-6">
                {t(cards[0].tagKey)}
              </span>
              <div className="w-8 h-8 flex items-center justify-center text-white/80 mb-4">
                <i className={`${cards[0].icon} text-2xl`} />
              </div>
              <h3 className="font-cormorant text-3xl font-light text-white leading-[1.25] mb-4">
                {t(cards[0].titleKey)}
              </h3>
              <p className="font-inter text-sm text-white/70 leading-relaxed max-w-md">
                {t(cards[0].descKey)}
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-6">
            {cards.slice(1, 3).map((s) => (
              <div key={s.titleKey} className="bg-canvas border border-sage/20 rounded-2xl p-7 flex-1 hover:border-sage/50 transition-all duration-200">
                <div className="w-7 h-7 flex items-center justify-center text-sage mb-3">
                  <i className={`${s.icon} text-lg`} />
                </div>
                <h3 className="font-inter font-semibold text-sm text-charcoal mb-2">{t(s.titleKey)}</h3>
                <p className="font-inter text-xs text-text-muted leading-relaxed line-clamp-3">{t(s.descKey)}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.slice(3).map((s) => (
            <div key={s.titleKey} className="bg-canvas border border-sage/20 rounded-2xl p-7 hover:border-sage/50 transition-all duration-200">
              <div className="w-7 h-7 flex items-center justify-center text-sage mb-3">
                <i className={`${s.icon} text-lg`} />
              </div>
              <h3 className="font-inter font-semibold text-sm text-charcoal mb-2">{t(s.titleKey)}</h3>
              <p className="font-inter text-sm text-text-muted leading-relaxed">{t(s.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
